import React, { useContext } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { Formik } from 'formik'
import * as Yup from 'yup'
import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import styles from './enrollment.module.scss'
import { EnrollmentContext, EnrollmentDispatch } from '../../context/enrollmentContext'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { correctPTlocale } from '@srca-b2b/kp5-ui-common/utils/helpers'

const EnrollmentStep1 = ({ children }) => {
  const dispatch = useContext(EnrollmentDispatch)
  const router = useRouter()

  const state = useContext(EnrollmentContext)
  const { registrationData } = state
  const { t } = useTranslation('common')

  let headerTitle = `${t('Register_for')} ${state.productTitle}`
  // NOTE: Some register flows use a header title that does not match the product title.
  if (state.productParam === null) {
    headerTitle = `${t('Register_for')} ${t('Knox_services')}`
  }

  //TODO / CHECK:  if first or last name from defaultValues API are empty, fields should be enabled for editing and required otherwise, fields should always be disabled

  const schema = Yup.object({
    email: Yup.string().email(t('Invalid_email_address')).required(t('Required'))
  })

  const onNextClick = (formValues) => {
    // fix for pt-br
    const userRegistrationLocale = correctPTlocale(router.locale)
    dispatch({
      type: 'STARTED_REGISTRATION',
      payload: { email: formValues.email, locale: userRegistrationLocale }
    })
  }

  const LoginAndRegisterUI = (
    <Container id="enrollment-step1" className="loginAndRegister">
      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <div className="registration-action text-center registration-fallback my-4 py-4">
            <div className="row">
              <div className="col-sm-12">
                <div className="mb-4 pt-4">
                  <Link href="/sso/signin">
                    <a id="sign-in">{t('Sign_in_with_a_Samsung_Account')}</a>
                  </Link>
                </div>
                <div className="mb-5 pb-5">
                  {t('Dont_have_a_Samsung_Account')}?{' '}
                  <Link href={`/sso/signup?email=${state.registrationData.email}`}>
                    <a id="sign-up">{t('Create_one_now')}</a>
                  </Link>
                  .
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )

  const EmailForm = (
    <Container id="enrollment-step1" className={classNames(styles.enrollmentStep1, 'emailForm')}>
      <Row>
        <Col className="mx-auto">
          <h4 className={classNames('text-center mb-3 mb-md-4', styles.headerTitle)}>
            {headerTitle}
          </h4>
          <div className="lead text-center pb-md-2 mb-md-4">{children}</div>
        </Col>
      </Row>
      <Formik
        validationSchema={schema}
        onSubmit={onNextClick}
        initialValues={{
          email: registrationData.email
        }}
      >
        {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <div className={styles.formBodyContainer}>
              <div className={styles.formBody}>
                <Form.Group as={Col} md={5} controlId="formEmail" className="mx-auto mb-5">
                  <Form.Label>
                    {t('Work_email')}
                    {/*<CustomTooltip
                        placement="top"
                        text="Log in to your existing Samsung Account or create a new Samsung Account associated with your work email address. Samsung Account allows for single-sign-on across all Knox solutions and services."
                      />*/}
                  </Form.Label>
                  <Form.Control
                    required
                    type="email"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={touched.email && !!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Group>
              </div>
            </div>
            <div className={classNames(styles.enrollmentButtonWrapper, 'text-right')}>
              <Button
                id="btn-submit"
                data-testid="btn-submit"
                type="submit"
                className={'btn-registration-next arrow-right ' + (!values.email ? 'disabled' : '')}
                disabled={!values.email}
              >
                {t('Next')}
                <span className={styles.changePageTitle}>: {t('Samsung_Account')}</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Container>
  )

  return (
    <div id="enrollment-step1">
      {state.isRegistrationStartFailed ? LoginAndRegisterUI : EmailForm}
    </div>
  )
}

export default EnrollmentStep1
